'use client'
import Header from '../component/header';
import Banner from '../component/banner';
import Footer from '../component/footer'
import EngagementSurveyQuestions from '../component/engagementsurveyquestions';
import EngagementSurveyContextProvider, { EngagementSurveyContext} from '../context/engagementsurveycontext';
import { Suspense, useContext, useEffect } from 'react';

const EngagementSurveyPage = () => {    

    return (
        <Suspense>
            <EngagementSurveyContextProvider>
                <InternalEngagementSurveyPage></InternalEngagementSurveyPage>
            </EngagementSurveyContextProvider>
        </Suspense>
    );
};

const InternalEngagementSurveyPage = () =>
{
    useEffect ( () => {
        document.title = 'The Encompass Group Survey';

        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = 'https://encstorage01.blob.core.windows.net/shr-profileimages/E3favicon.png';
    }, []);
    
    const {
        displayMessage,        
        bannerText,
        isError
    } = useContext(EngagementSurveyContext);

    return(
        <>
            <Header singleSurvey={true}/>
            <Banner displayMessage={displayMessage} bannerText={bannerText} isError={isError} singleSurvey={true}  wlSurvey={false} />
            <EngagementSurveyQuestions />
            <Footer singleSurvey={true}/>
        </>
    )
}

export default EngagementSurveyPage;